











































































































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { QPage } from 'quasar'

import { Virtual } from 'swiper'
import { Swiper, SwiperSlide, } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

// import { Virtual } from "swiper"
// import { Swiper, SwiperSlide } from 'swiper/vue'
// import 'swiper/css'

// to enabale virtual slides in vue3 see:
// https://swiperjs.com/vue
// https://blog.devgenius.io/add-a-swiper-carousel-into-a-vue-3-app-with-swiper-6-672be704bcb6
// and remove updated () method from component (this is hack for vue-awesome-swiper :auto-update="false")

import Timer from 'components/Timer.vue'
import MarkdownViewerCrdt from 'components/MarkdownViewerCrdt.vue'
import SlidesViewerSlide from 'components/presenter/item/topic/viewer/SlidesViewerSlide.vue'
import SlideView from 'components/presenter/item/topic/viewer/View.vue'
import SlidesViewerGrid from 'components/presenter/item/topic/viewer/SlidesViewerGrid.vue'
import SlidesViewerThumbnails from 'components/presenter/item/topic/viewer/SlidesViewerThumbnails.vue'

@Component({
  components: {
    Swiper,
    SwiperSlide,
    Timer,
    MarkdownViewerCrdt,
    SlidesViewerSlide,
    SlideView,
    SlidesViewerGrid,
    SlidesViewerThumbnails
  }
})
export default class ItemTopicViewerSlidesViewer extends Vue {
  // Virtual = Virtual
  gridView = false
  timerStart = new Date().getTime()

  @Prop()
  readonly value!: string

  @Prop()
  readonly slides!: Json[]

  @Prop({ default: true })
  readonly navigate!: boolean

  @Prop({ default: false })
  readonly keynote!: boolean

  @Prop({ default: false })
  readonly showNotes!: boolean


  @Prop()
  readonly seed!: string | undefined

  @Prop({ default: () => { return {} } })
  readonly params!: Json

  @Prop({ default: () => { return {} } })
  readonly response!: Json

  @Prop()
  readonly attendeeResponseResult!: Json

  @Prop({ default: () => { return {} }})
  readonly stats!: Json | undefined

  @Prop({ default: false })
  readonly readonly!: boolean

  @Prop({ default: false })
  readonly feedbackButtonsShow!: boolean

  @Prop({ default: false })
  readonly feedbackButtonsShowAlways!: boolean

  @Prop({ default: () => { return {} } })
  readonly feedbackButtonsOn!: Json


  // @Ref()
  // readonly viewer!: QPage

  get visibleSlides () {
    return this.slides.filter(slide => slide.type !== 'Params')
  }

  get options () {
    return {
      // modules: [Virtual],
      // virtual: true,
      longSwipesMs: 0,
      longSwipesRatio: 0.25,
      allowTouchMove: this.navigate,
      spaceBetween: 16
    }
  }

  get carousel () {
    // @ts-ignore
    return this.$refs.carousel.$swiper
  }

  mounted () {
    this.$nextTick(() => {
      this.select(this.value, '', 0)
    })
  }

  updated () {
    this.carousel.update()
  }

  @Watch('navigate')
  toggleNavigate(navigate: boolean) {
    this.carousel.allowTouchMove = navigate
  }

  @Watch('slides')
  onSlidesChange () {
    this.$nextTick(() => {
      this.select(this.value, '', 0)
    })
  }

  @Watch('value')
  select (idTo: string, idFrom: string | undefined, duration: number | undefined) {
    const index = this.carousel.slides.findIndex((s: Json) => s.attributes['slide-id']?.value === ''+idTo)
    this.goto(index === -1 ? 0 : index, duration)
    this.gridView = false
  }

  change () {
    this.timerStart = new Date().getTime()
    const slideId = this.carousel.slides[ this.carousel.realIndex ].attributes['slide-id']?.value
    if (this.value !== slideId) {
      this.$emit('update', slideId)
      // this.$nextTick(() => {
      //   (this.viewer.$el as HTMLElement).focus()
      // })
    }
  }

  goto (index: number, duration: number | undefined) {
    this.carousel.slideTo(index, duration)
  }

  prev () {
    this.carousel.slidePrev()
  }

  next () {
    this.carousel.slideNext()
  }

  resize () {
    // @ts-ignore
    this.$refs.carousel.$swiper && this.$refs.carousel.$swiper.update()
  }
}
